import { render, staticRenderFns } from "./AddFaceDialog.vue?vue&type=template&id=36017bea&scoped=true&"
import script from "./AddFaceDialog.vue?vue&type=script&lang=js&"
export * from "./AddFaceDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddFaceDialog.vue?vue&type=style&index=0&id=36017bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36017bea",
  null
  
)

export default component.exports